import { LoginData } from '../model/LoginData';

const HTTP_METHOD_GET = 'GET';
const HTTP_METHOD_POST = 'POST';
const HTTP_MAIN_HEADERS = {
  'Content-Type': 'application/json',
};

type ErrorFn = (err: any, httpCode?: number) => void;
type ResponseFn<T> = (response: T) => void;

export function post<T, R>(
  path: string | undefined,
  data: T,
  onResponse: ResponseFn<R>,
  onError?: ErrorFn,
  loginData?: LoginData | null,
  extraHeaders?: HeadersInit
): void {
  genericRequest(
    path,
    onResponse,
    HTTP_METHOD_POST,
    {
      ...HTTP_MAIN_HEADERS,
      ...extraHeaders,
    },
    JSON.stringify(data),
    loginData,
    onError
  );
}
export function get<T>(
  path: string | undefined,
  onResponse: ResponseFn<T>,
  onError?: ErrorFn,
  loginData?: LoginData | null,
  extraHeaders?: HeadersInit
) {
  genericRequest(path, onResponse, HTTP_METHOD_GET, extraHeaders, undefined, loginData, onError);
}

function genericRequest<R>(
  path: string | undefined,
  onResponse: (response: R) => void,
  method: string,
  headers?: HeadersInit,
  body?: BodyInit,
  loginData?: LoginData | null,
  onError?: ErrorFn
): void {
  let reqHeaders: HeadersInit | undefined = undefined;
  if (loginData?.user?.token && headers) {
    reqHeaders = {
      ...headers,
      token: loginData?.user?.token,
    };
  } else if (headers) {
    reqHeaders = headers;
  } else if (loginData?.user?.token) {
    reqHeaders = {
      token: loginData?.user?.token,
    };
  }

  const init = {
    method: method,
    headers: reqHeaders,
    body: body,
  };

  fetch((process.env.REACT_APP_API_URL ?? '') + path, init)
    .then((response) => {
      if (response.ok) {
        response
          .json()
          .then((result) => {
            onResponse(result);
          })
          .catch(() => errorCallback(response.status, undefined, onError));
      } else {
        if (response.headers.get('Content-Length') === '0') {
          errorCallback(response.status, undefined, onError);
        } else {
          response
            .json()
            .then((result) => {
              errorCallback(response.status, result.Message, onError);
            })
            .catch(() => errorCallback(response.status, undefined, onError));
        }
      }
    })
    .catch((error) => errorCallback(undefined, error, onError));
}

function errorCallback(httpCode?: number, reason?: any, otherCallback?: ErrorFn): void {
  console.log(`[api] status: ${httpCode}. Message: ${reason}`);
  otherCallback?.(reason, httpCode);
}
